export const learnosityScriptVersion = 'v2025.2.LTS';
